<template>
  <div>
    <el-form class="form" :inline="true" :model="queryInfo" style="margin-bottom: -10px;">
      <div>
        <el-form-item label="所属电站">
          <el-select v-model="xuanzedianzhan" placeholder="请选择电站" @change="sousuo" filterable>
            <el-option v-for="item in station_list_all" :key="item.stationId" :label="item.stationName"
              :value="item.stationId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="电桩编号">
          <el-input placeholder="请输入电桩编号" v-model="queryInfo.pileCode" @change="current">
          </el-input>
        </el-form-item>
        <el-form-item label="电桩类型：">
          <el-select v-model="queryInfo.pileType" placeholder="请选择电桩类型" @change="pileTyping" filterable>
            <el-option v-for="item in pileType_list" :key="item.pileType" :label="item.label" :value="item.pileType">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="通讯状态：">
          <el-select v-model="queryInfo.commStatus" placeholder="请选择通讯状态" @change="tongxun" filterable clearable>
            <el-option v-for="item in tongxun_list" :key="item.commStatus" :label="item.name" :value="item.commStatus">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="工作状态：" v-if="zhuangkuang == true">
          <el-select v-model="queryInfo.gunState" placeholder="请选择工作状态" @change="leixing" filterable>
            <el-option v-for="item in gongzuo_list" :key="item.gunState" :label="item.name" :value="item.gunState">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="check_event">查询</el-button>
          <el-button type="primary" icon="el-icon-refresh-left" @click="chongzhi">重置</el-button>
        </el-form-item>
        <!-- <el-form-item>
            <el-button @click="changePile">切换新版</el-button>
          </el-form-item> -->
      </div>
      <!--</el-col> -->
    </el-form>
  <!-- 卡片视图区域 -->
  <el-card class="card">
    <li style="display: flex;flex-direction: row;justify-content: flex-end;margin: -10px 0 10px -1%;">
          <el-button type="success" icon="el-icon-plus" v-if="tianjiadianzhaung" @click="showElePile">添加设备</el-button> <el-button v-if="shanchu" type="danger" icon="el-icon-delete" @click="removeById">批量删除</el-button>
        </li>
    <!-- table表格区域 -->
    <el-table class="table" :data="elePileList" border @row-dblclick="dbclick" :lazy="true"
      @selection-change="handleSelectionChange" empty-text="暂无数据">
      <el-table-column align="center" type="selection" width="55"></el-table-column>
      <el-table-column align="center" type="expand">
        <template slot-scope="scope">
          <el-form label-position="left" class="demo-table-expand">
            <el-row :gutter="20" type="flex" class="row-bg" justify="space-around" style="display: flex;flex-direction: row;padding: 0 1%;">
              <el-col :span="6">
                <el-form-item label="出胶长度:">
                  <span> {{ scope.row.glueDispensingLength }}cm</span>
                </el-form-item>
                <el-form-item label="额定电流:">
                  <span> {{ scope.row.current }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="网关编号:">
                  <span> {{ scope.row.gatewayCode }}</span>
                </el-form-item>
                <el-form-item label="硬件故障:">
                  <span> {{ scope.row.error }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="功率:">
                  <span> {{ scope.row.power }}kwh</span>
                </el-form-item>
                <el-form-item label="sim卡信号强度:">
                  <span> {{ scope.row.simSignal }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="sim卡运营商:">
                  <span> {{ scope.row.telecomOperator }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </template>
      </el-table-column>
      <!-- <el-table-column align="center" label="ID" prop="id"></el-table-column> -->
      <el-table-column align="center" label="名称" prop="name">
        <template slot-scope="scope">
                <span>{{ scope.row.adminName }}</span>
              </template>
      </el-table-column>
      <el-table-column align="center" label="设备型号" prop="code">
        <template slot-scope="scope">
                <span>{{ scope.row.code }}</span>
              </template>
      </el-table-column>
      <el-table-column align="center" label="设备编码" prop="number">
        <template slot-scope="scope">
                <span>{{ scope.row.number }}</span>
              </template>
      </el-table-column>
      <!-- <el-table-column align="center" label="出胶长度" prop="glueDispensingLength" width="100">
        <template slot-scope="scope">
          <div>
            {{ scope.row.glueDispensingLength}}cm
          </div>
        </template>
      </el-table-column> -->
      <el-table-column align="center" label="设备类型" prop="type" width="80">
        <template slot-scope="scope">
          <div>
            {{ scope.row.type == 2 ? '点胶机' : '载钉机' }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="开机状态" prop="powerOnStatus" width="80">
        <template slot-scope="scope">
          <div>
            {{ scope.row.powerOnStatus == 0 ? '已开机' : '未开机' }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="开机时间" prop="powerOnStartTime" width="100">
        <template slot-scope="scope">
          <div>
            {{ scope.row.powerOnStartTime }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="关机时间" prop="powerOnEndTime" width="100">
        <template slot-scope="scope">
          <div>
            {{ scope.row.powerOnStartTime }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="通讯状态" prop="commStatus" width="90">
        <template slot-scope="scope">
          <div>
            {{ scope.row.commStatus == 0 ? '已下线' : scope.row.commStatus == 1 ? '很好' : scope.row.commStatus == 2 ?
      '正常' : scope.row.commStatus == 3 ? '一般' : '很差' }}
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column align="center" label="网络连接类型" prop="netType" width="110">
        <template slot-scope="scope">
          <div>
            {{ scope.row.netType == 0 ? '4G路由':scope.row.netType == 1 ? '以太网': 'DTU' }}
          </div>
        </template>
      </el-table-column> -->
      <el-table-column align="center" label="告警状态" prop="alarm" width="140">
        <template slot-scope="scope">
                <span>{{ scope.row.alarm }}</span>
              </template>
      </el-table-column>
      <el-table-column align="center" label="管控" prop="state" width="60">
        <template slot-scope="scope">
          <div>
            {{ scope.row.state == 0 ? '正常' : '禁用' }}
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column align="center" label="网关编号" prop="gatewayCode" width="100"></el-table-column> -->
      <el-table-column align="center" label="sim卡" prop="sim">
        <template slot-scope="scope">
                <span>{{ scope.row.sim }}</span>
              </template>
      </el-table-column>
      <!-- <el-table-column align="center" label="sim卡信号强度" prop="simSignal" width="140"></el-table-column> -->
      <el-table-column align="center" label="创建时间" prop="createTime" width="100">
        <template slot-scope="scope">
          <div>
            {{ scope.row.createTime }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="更新时间" prop="updateTime" width="100">
        <template slot-scope="scope">
          <div>
            {{ scope.row.updateTime }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="left" label="操作" width="190" fixed="right">
        <template slot-scope="scope">
          <!-- :disabled="dianzhuangrizhi_disabled" -->
          <el-button size="small" type="primary" icon="el-icon-edit" @click="showElePile(scope.row)"
            v-if="bianji">编辑</el-button>
          <el-button size="small" @click="dianzhuangrizhi(scope.row)"
            :disabled="scope.row.d_z_r_z_anniu">电桩日志</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 添加&编辑设备的对话框 -->
    <el-dialog :title="title" :visible.sync="elePileVisible" width="35%" append-to-body :close-on-click-modal="false" @closed="qx1">
      <!-- 内容主体区域 -->
      <el-form :model="elePileForm" :rules="loginFormRules" ref="elePileRef" label-width="95px">
        <el-form-item label="设备型号" prop="code">
          <el-input v-model="elePileForm.code" style="width: 100%;" @change="changing"></el-input>
        </el-form-item>
        <el-form-item label="设备编码" prop="number">
          <el-input v-model="elePileForm.number" style="width: 100%;" @change="changing"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="des">
          <el-input v-model="elePileForm.des" style="width: 100%;" @change="changing"></el-input>
        </el-form-item>
        <el-form-item label="设备类型" prop="type">
          <el-select v-model="elePileForm.type" filterable>
            <el-option v-for="  item   in   gunOptions  " :key="item.type" :label="item.name" :value="item.type">
            </el-option>
          </el-select>
        </el-form-item>

      </el-form>
      <!-- 底部按钮区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="qx1">取 消</el-button>
        <el-button type="primary" @click="editElePile">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 电桩日志 -->
    <el-dialog title="电桩日志" :visible.sync="rizhi" width="50%" :close-on-click-modal="false" :before-close="quxiao"
      @closed="quxiao">
      <div class="table">
        <el-table :data="tableData" stripe style="width: 100%" empty-text="暂无数据">
          <el-table-column prop="pileIpAddr" label="登录IP">
            <template slot-scope="scope">
                <span>{{ scope.row.pileIpAddr }}</span>
              </template>
          </el-table-column>
          <el-table-column prop="threadId" label="连接线程">
            <template slot-scope="scope">
                <span>{{ scope.row.threadId }}</span>
              </template>
          </el-table-column>
          <el-table-column prop="pileCode" label="登陆桩号">
            <template slot-scope="scope">
                <span>{{ scope.row.pileCode }}</span>
              </template>
          </el-table-column>
          <el-table-column prop="loginTime" label="上线时间">
            <template slot-scope="scope">
                <span>{{ scope.row.loginTime }}</span>
              </template>
          </el-table-column>
          <el-table-column prop="loginOutTime" label="离线时间">
            <template slot-scope="scope">
              <span v-if="scope.row.loginOutTime != null">{{ scope.row.loginOutTime }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column prop="loginState" label="登录状态">
            <template slot-scope="scope">
              <el-tag type="info" v-model="scope.row.loginState" v-if="scope.row.loginState == '1'">离线</el-tag>
              <el-tag type="success" v-model="scope.row.loginState" v-if="scope.row.loginState == '0'">成功</el-tag>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handlesize" @current-change="handleCurrent" :current-page="rizi.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="rizi.limit" layout="total, sizes, prev, pager, next, jumper"
          :total="total_all" background>
        </el-pagination>
      </div>
    </el-dialog>
  </el-card>
  </div>
</template>

<script>
import { saveBlobToFile } from '@/utils/saveBlobToFile';
import caozuo from "@/utils/pubilc.js";
export default {
  name: 'elePileWorld',
  props: {
    loading: Boolean,
    limit: { //限制文件上传个数
      type: Number,
      default: 1
    }
  },
  data() {
    // 电桩编号的校验规则
    const checkpileCode = (rule, value, callback) => {
      const reg = /^[a-zA-Z0-9]+$/
      if (reg.test(value)) {
        return callback()
      }
      callback(new Error('电桩编号由数字、字母或者或者其中一种组成'))
    }
    return {
      loginFormRules:{
code:{
required:true,message:'请输入设备编码',trigger:'blur'
},
number:{
  required:true,message:'请输入设备型号',trigger:'blur'
}
      },
      defaultType: false,
      autosize: false,
      yincang: true,
      daochu: 162,
      zhuangkuang: false,
      bianji: false,
      chongqi_btn: false,
      tianjiadianzhaung: false,
      shanchu: false,
      piliangqianyi: false,
      daoru: false,
      pileType_list: [
        {
          pileType: 0,
          label: '锐创直流桩'
        },
        {
          pileType: 1,
          label: '锐创交流桩'
        },
        {
          pileType: 2,
          label: '无疆(二代)交流桩'
        },
        {
          pileType: 3,
          label: '光法(一代)直流桩'
        },
        {
          pileType: 4,
          label: '光法(一代)交流桩'
        },
        {
          pileType: 5,
          label: '锐创低速桩'
        }
      ],
      tongxun_list: [
        {
          commStatus: 0,
          name: '已下线'
        }, {
          commStatus: 1,
          name: '很好'
        },
        {
          commStatus: 2,
          name: '正常'

        }, {
          commStatus: 3,
          name: '一般'
        }, {
          commStatus: 4,
          name: '很差'
        }],
      gongzuo_list: [
        {
          gunState: 0,
          name: '空闲中'
        }, {
          gunState: 1,
          name: '准备开始充电'
        },
        {
          gunState: 2,
          name: '充电进行中'

        }, {
          gunState: 3,
          name: '充电结束'
        }, {
          gunState: 4,
          name: '启动失败'
        },
        {
          gunState: 5,
          name: '预约状态'
        }, {
          gunState: 6,
          name: '系统故障'
        },
        {
          gunState: 7,
          name: '升级中'
        }
      ],
      limitTypeOptions: [{
        limitType: 0,
        label: '全部允许'
      }, {
        limitType: 1,
        label: '禁止小程序用户'
      }, {
        limitType: 2,
        label: '禁止电卡用户'
      }, {
        limitType: 4,
        label: '禁止小程序和电卡用户'
      },
      {
        limitType: 3,
        label: '禁止Vin用户'
      },
      {
        limitType: 5,
        label: '禁止小程序和Vin用户'
      },
      {
        limitType: 6,
        label: '禁止电卡和Vin用户'
      }],
      zhuangtai: false,
      qianghao: '',
      dianzhuanghao: '',
      url: '',
      codeText: "",
      dialogVisible: false,
      dianzhuangrizhi_disabled: false,
      ids4: 0,
      xuanzedianzhan: null,
      code: null,
      pageSize_all: 0,
      total_all: 100,
      currentPage3: 0,
      tableData: [],
      rizhi: false,
      newstationIds: null,
      qianyidizhi: false,
      qianyidianzhuang: '',
      // # config
      extAccept: ["xls", "xlsx"],
      // # state
      importDialogVisible: false,
      // # data
      formData: {
        fileList: []
      },
      // 查询所有电桩列表的参数
      queryInfo: {
        pileCode: null,
        stationIds: null,
        gunState: null,
        commStatus: null,
        page: 1,
        limit: 8,
        pileType: null,
        stationMode: '0,1',
        roleId: window.sessionStorage.getItem('roleId')
      },
      rizi: {
        pileCode: null,
        startTime: null,
        endTime: null,
        page: 1,
        limit: 10
      },
      total: 0,
      // 枪号数据
      gunOptions: [
        {
          type: 2,
          name: '点胶机'
        },
        {
          type: 3,
          name: '载钉机'
        }
      ],
      gunOptions2: [
        {
          netType: 0,
          name: '4G路由'
        },
        {
          netType: 1,
          name: '以太网'
        },
        {
          netType: 2,
          name: 'DTU'
        }
      ],
      gunOptions3: [
        {
          gunNumber: 0,
          name: '正常'
        },
        {
          gunNumber: 1,
          name: '禁用'
        }
      ],
      gunOptions4: [
        {
          netType: 0,
          name: '已下线'
        },
        {
          netType: 1,
          name: '很好'
        },
        {
          netType: 2,
          name: '正常'
        },
        {
          netType: 3,
          name: '一般'
        },
        {
          netType: 4,
          name: '很差'
        }
      ],
      // 功率数据
      chapOptions: [
        {
          value: 0,
          label: 0
        },
        {
          value: 7,
          label: 7
        },
        {
          value: 11,
          label: 11
        },
        {
          value: 14,
          label: 14
        },
        {
          value: 20,
          label: 20
        },
        {
          value: 22,
          label: 22
        },
        {
          value: 30,
          label: 30
        },
        {
          value: 40,
          label: 40
        },
        {
          value: 60,
          label: 60
        },
        {
          value: 80,
          label: 80
        },
        {
          value: 120,
          label: 120
        },
        {
          value: 140,
          label: 140
        },
        {
          value: 160,
          label: 160
        },
        {
          value: 180,
          label: 180
        },
        {
          value: 200,
          label: 200
        },
        {
          value: 240,
          label: 240
        },
        {
          value: 260,
          label: 260
        },
        {
          value: 300,
          label: 300
        },
        {
          value: 320,
          label: 320
        },
        {
          value: 360,
          label: 360
        },
        {
          value: 400,
          label: 400
        },
        {
          value: 480,
          label: 480
        },
        {
          value: 600,
          label: 600
        }
      ],
      // 充电类型
      chatOptions: [
        {
          pileClassType: '0',
          label: '慢充'
        },
        {
          pileClassType: '1',
          label: '快充'
        },
        {
          pileClassType: '2',
          label: '低速'
        }
      ],
      // 电桩类型
      devtOptions: [
        {
          pileType: 0,
          label: '锐创直流桩'
        },
        {
          pileType: 1,
          label: '锐创交流桩'
        },
        {
          pileType: 2,
          label: '无疆(二代)交流桩'
        },
        {
          pileType: 3,
          label: '光法(一代)直流桩'
        },
        {
          pileType: 4,
          label: '光法(一代)交流桩'
        },
        {
          pileType: 5,
          label: '锐创低速桩'
        }
      ],
      stationName: [],
      comTypeOptions: [
        {
          label: '4G路由',
          netType: 0
        }, {
          label: '以太网',
          netType: 1
        }, {
          label: 'DTU',
          netType: 2
        }
      ],
      // 电桩列表及参数
      elePileList: [],
      page_num: 0,
      page_num1: 0,
      elePileForm: {
        id: null,
        code: '',
        number: '',
        type: 2
      },
      ids1: 0,
      ids2: 0,
      ids3: 0,
      elePileVisible: false,
      title: '',
      value: '',
      shows: false,
      pileNumbers: null,
      ids: '',
      powerStation: [],
      canshu: {},
      checked_all: '',
      station_list: [],
      station_list_listall: [],
      station_list_all: [],
      caozuoquanxian: false,
      gunState: null,
      commStatus: null,
      zhuangtai_quanxian: false,
    }
  },
  computed: {
    extAcceptStr() {
      return this.extAccept.map(ext => `.${ext}`).join(",")
    },
  },
  watch: {
    'queryInfo.stationIds': {
      handler(newValue) {
        if (newValue == null) {
          this.queryInfo.stationIds = window.sessionStorage.getItem('stationIds');
        } else {
          this.queryInfo.stationIds = newValue
        }
      }
    }
  },
  created() {
    const that = this;
    caozuo(170).then(res => {
      that.zhuangtai_quanxian = res;
    });
    caozuo(156).then(res => {
      that.bianji = res;
    });
    caozuo(162).then(res => {
      that.daochu = res;
    });
    caozuo(95).then(res => {
      that.chongqi_btn = res;
    });
    caozuo(159).then(res => {
      that.tianjiadianzhaung = res;
    });
    caozuo(157).then(res => {
      that.shanchu = res;
    });
    caozuo(158).then(res => {
      that.daoru = res;
    });
    caozuo(160).then(res => {
      that.piliangqianyi = res;
    });
    that.getPowerStationList();
  },
  methods: {
    dbclick(row, column, event) {
      // console.log(event.currentTarget.querySelector(".el-table__expand-icon"))
      if (event.currentTarget.querySelector(".el-table__expand-icon")) {
        event.currentTarget.querySelector(".el-table__expand-icon").click()
      }
    },
    changePile() {
      this.$emit('fatherMethod', 1);
    },
    chunkArray(array, chunkSize) {
      return Array.from({ length: Math.ceil(array.length / chunkSize) }, (v, i) => array.slice(i * chunkSize, i * chunkSize + chunkSize));
    },
    changing() {
      const that = this;
      that.$http.get(`pileInfo/getPileInfoCodeById/${that.elePileForm.pileCode}`).then(res => {
        if (res.data.code !== 0) return;
        that.$message.error('电桩编号已存在');
        that.elePileForm.pileCode = '';
      })
    },
    // 编辑的取消按钮；
    qx1() {
      this.$refs.elePileRef.resetFields();
      this.elePileVisible = false;
      this.elePileForm = {};
    },
    handleClose() {
      this.dialogVisible = false;
      this.url = '';
      this.dianzhuanghao = '';
    },
    zhanshi() {
      this.yincang = !this.yincang
    },
    // 重启
    async chongqi(e) {
      this.ids2 = e.id;
      const confirmResult = await this.$confirm('此操作将重启, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      if (confirmResult !== 'confirm') {
        e.c_q_anniu = false;
        this.$message.info('已取消重启！')
      } else {
        this.$http.get(`/pileInfo/Restart/${e.pileCode}/${Number(window.sessionStorage.getItem('adminId'))}`).then(res => {
          if (res.data.code == 0) {
            e.c_q_anniu = true;
            this.$message.success(res.data.msg)
          } else {
            e.c_q_anniu = false;
            this.$message.error(res.data.msg)
          }
        })
      }
    },
    // 加载更多
    jizaigengduo() {
      this.zhuangkuang = !this.zhuangkuang;
    },
    // 改变电桩状态
    async change_pileState(row) {
      const { data: res } = await this.$http.post('pileInfo/updateStateByPileCode', {
        pileCode: row.pileCode,
        pileState: row.pileState
      })
      if (res.code !== 0) return this.$message.error(res.msg)
      this.$message.success('编辑电桩成功！')
      this.check_event();
      this.elePileVisible = false
    },
    // 重置搜索条件
    chongzhi() {
      this.queryInfo = {
        pileCode: null,
        stationIds: null,
        gunState: null,
        commStatus: null,
        page: 1,
        limit: 8,
        pileType: null,
        stationMode: '0,1',
        roleId: window.sessionStorage.getItem('roleId'),
      };
      this.xuanzedianzhan = null;
      this.getPowerStationList();
    },
    // 获取电站列表
    async getPowerStationList() {
      const that = this;
      that.elePileList = [];
      that.queryInfo.stationIds = that.queryInfo.stationIds == null ? window.sessionStorage.getItem('stationIds') : that.queryInfo.stationIds;
      that.$http.get('kc-device-info/getAllKcDeviceInfo', {
        params: {
          pileCode: that.queryInfo.pileCode,
          stationIds: that.queryInfo.stationIds,
          gunState: that.queryInfo.gunState,
          commStatus: that.queryInfo.commStatus,
          page: that.queryInfo.page,
          limit: that.queryInfo.limit,
          pileType: that.queryInfo.pileType == null ? "0,1,2,3,4,5" : that.queryInfo.pileType,
          roleId: that.queryInfo.roleId,
        }
      }).then(res => {
        if (res.data.code == 0) {
          that.elePileList = res.data.data;
          that.elePileList.forEach(item => {
            item.b_j_anniu = false; item.c_q_anniu = false; item.d_z_r_z_anniu = false
          });
          that.total = res.data.count;

        }
      })
      let a = null;
      that.station_list_all = [];
      that.station_list = [];
      let abc = {
      roleId: window.sessionStorage.getItem('roleId'),
      stationMode: '0,1',
      stationIds: window.sessionStorage.getItem('stationIds')
    }
    const roleId = window.sessionStorage.getItem('roleId');
    if (roleId ==1 || roleId == 2 || roleId == 3 || roleId == 10) {
      this.$delete(abc, 'stationIds')
    }
      await that.$http.get('station-info/getAllStationInfoName', {
        params: abc
      }).then(resb => {
        resb.data.data.forEach((item) => {
          that.station_list.push({
            stationId: item.id,
            stationName: item.stationName
          });
          that.station_list_all.push({
            stationId: item.id,
            stationName: item.stationName
          });
        })
      })

    },
    // 搜索
    sousuo(e) {
      this.queryInfo.page = 1;
      this.queryInfo.stationIds = e;
    },
    current() {
      this.queryInfo.page = 1;
    },
    // 工作状态
    leixing(e) {
      this.queryInfo.page = 1;
      this.queryInfo.gunState = e;
    },
    // 电桩类型
    pileTyping(e) {
      this.queryInfo.page = 1;
      this.queryInfo.pileType = e;
      this.getPowerStationList()
    },
    // 通讯状态
    tongxun(e) {
      this.queryInfo.page = 1;
      this.queryInfo.commStatus = e;
    },
    // 复选框选择事件
    async check_event() {
      this.elePileList = [];
      this.queryInfo.page=1;
      this.queryInfo.stationIds == null ? window.sessionStorage.getItem('stationIds') : this.xuanzedianzhan;
      this.getPowerStationList()
    },
    // 改变电站
    change_station(e) {
      this.queryInfo.stationIds = e;
    },
    // 设置二维码
    shezhierweima(row) {
      this.ids3 = row.id;
      this.dialogVisible = true;
      if (row.qrCodeType == 0) {
        this.url = row.qrCode;
      } else {
        this.url = row.publicQrCode;
      };
      this.dianzhuanghao = row.pileCode + row.gunNumberName;
    },
    // 改变页码
    handleCurrent(newPage) {
      this.rizi.page = newPage
      // 页码跳跃
      this.public_function()
    },
    // 改变数据条数
    handlesize(newSize) {
      this.rizi.limit = newSize;
      this.rizhi.page=1;
      // 页码跳跃
      this.public_function()
    },
    quxiao() {
      this.rizhi = false;
      this.elePileList.forEach(item => {
        if (item.id == this.ids4) {
          item.d_z_r_z_anniu = false
        }
      })
    },
    public_function() {
      this.rizi.pileCode = this.code;
      this.$http.get('pile-login-log/getAllPileLoginLog', {
        params: this.rizi
      }).then(resb => {
        this.total_all = resb.data.count;
        this.tableData = resb.data.code !== 0 ? [] : resb.data.data;
        this.rizhi = resb.data.code !== 0 ? false : true;
        this.dianzhuangrizhi_disabled = resb.data.code !== 0 ? true : false;
        if (resb.data.code !== 0) {
          this.$message.error('暂无电桩日志');
        }
        this.dianzhuangrizhi_disabled = false;
        // if (val == 1) {
        //   this.total_all = resb.data.count;
        //   this.pageSize_all = Math.ceil(this.total_all / 5);
        //   console.log(this.pageSize_all, 'this.pageSize_all');
        // }

      })
    },
    async dianzhuangrizhi(row) {
      this.ids4 = row.id;
      if (this.currentPage3 == 0) {
        this.currentPage3 = 1
      };
      this.code = row.pileCode;
      this.public_function()
      // this.public_function(this.currentPage3)
    },
    qianyi_station(e) {
      this.newstationIds = e;
    },
    qinyidizhi2() {
      this.$http.post('/pileInfo/updPileInfoStationId?ids=' + this.ids + '&stationId=' + this.newstationIds + '&adminId=' + Number(window.sessionStorage.getItem('adminId'))).then(res => {
        if (res.data.code == 0) {
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg);
        }
        this.qianyidizhi = false;
        this.getPowerStationList();
      })
    },
    qinyidizhi3() {
      this.qianyidianzhuang = '';
      this.qianyidizhi = false;
    },
    qianyi() {
      const that = this;
      that.station_list_listall = [];
      if (that.queryInfo.pileType == null || that.queryInfo.pileType == undefined || that.queryInfo.pileType.length == 0 || that.pileNumbers == '') return that.$message.error(`请先选择你要迁移的
      ${that.pileNumbers == '' && that.queryInfo.pileType == '' ? '电桩、设备类型' : that.pileNumbers == '' ? '电桩' : '设备类型'}`);
      console.log(that.queryInfo.pileType, '1064');
      this.qianyidizhi = true;
      let abc = {
      roleId: window.sessionStorage.getItem('roleId'),
      stationMode: that.queryInfo.pileType == 6 ? '2' : '0,1',
      stationIds: window.sessionStorage.getItem('stationIds')
    }
    const roleId = window.sessionStorage.getItem('roleId');
    if (roleId ==1 || roleId == 2 || roleId == 3 || roleId == 10) {
      this.$delete(abc, 'stationIds')
    }
      that.$http.get('station-info/getAllStationInfoName', {
        params:abc
      }).then(res => {
        if (res.data.code !== 0) return;
        res.data.data.forEach(item => {
          that.station_list_listall.push({
            stationId: item.id,
            stationName: item.stationName
          })
        })
      })
    },
    importElePile() {
      this.importDialogVisible = true
    },
    onClose() {
      this.importDialogVisible = false
    },
    onAfterClose() {
      this.formData = {
        fileList: []
      }
    },
    // # upload
    // 校验
    validateFile(file) {
      if (!file) return "至少添加一个文件！"
      const ext = (file.name || "").split(".")[1]
      if (!this.extAccept.includes(ext))
        return `仅支持${this.extAcceptStr}格式的文件`
      return ""
    },
    // 选择文件的改变事件
    onFileChange(file, fileList) {
      const errMsg = this.validateFile(file)
      if (errMsg) {
        this.$message.error(errMsg)
        this.formData.fileList.splice(0, 1)
      } else {
        this.formData.fileList = fileList
      }
    },
    onFileMove(file, fileList) {
      this.formData.fileList = fileList
    },
    onFileExceed() {
      this.$message.error(`仅允许上传 ${this.limit} 个文件！`)
    },
    // # emit
    // 模板下载
    // async onDownload() {
    //   const { data: res } = await this.$http.get('chargingPile/exportExcel/' + 2940, { responseType: 'blob' })
    //   saveBlobToFile(res, '电桩模板')
    //   if (res.data.code != 0) {
    //     this.$message.error(res.msg)
    //   }
    //   this.$message.success(res.msg)
    // },
    // 导入
    async onSubmit() {
      var formData = new FormData()
      for (const file of this.formData.fileList) {//多个文件全部都放到files
        if (file.raw) {
          formData.append('file', file.raw);
          formData.append('adminId', window.sessionStorage.getItem('adminId') * 1)
        }
      }
      const { data: res } = await this.$http.post('pileInfo/importPileInfo', formData)
      this.importDialogVisible = false
      if (res.data.code != 0) {
        this.$message.error(res.msg)
        this.check_event()
      } else {
        this.$message.success(res.msg)
      }
    },
    changesize(newSize) {
      this.queryInfo.limit = newSize;
      this.getPowerStationList()
    },
    // 监听页码值改变的事件
    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage
      this.getPowerStationList()
    },
    // 展示添加&编辑设备对话框
    async showElePile(row) {
      const that = this;
      that.title=row.id == null || row.id == undefined?'添加设备':'编辑设备';
      if (row.id == null || row.id == undefined) return that.elePileVisible = true;
      const { data: resb } = await this.$http.get('kc-device-info/getAllKcDeviceInfo', {
        params: {
          id: row.id,
          page: 1,
          limit: 10,
          roleId: window.sessionStorage.getItem('roleId')
        }
      })
      that.elePileForm = resb.data[0];
      that.elePileVisible = true;
    },
    // 添加&编辑设备提交事件
    editElePile() {
      this.$refs.elePileRef.validate(async valid => {
        if (!valid) return;
        if(this.elePileForm.number)return this.$message.error('请输入设备型号');
        if(this.elePileForm.code)return this.$message.error('请输入设备编码');
        const { data: res } = await this.$http.post('kc-device-info/editKcDeviceInfo', this.elePileForm)
        if (res.code !== 0) return this.$message.error(res.msg)
        this.$message.success(`${this.title}成功！`)
        this.check_event()
        this.elePileVisible = false
      })
    },
    elePileDialogClosed() {
      this.shows = false
      this.$refs.elePileRef.resetFields()
    },
    // 删除电桩
    async removeById(row) {
      const confirmResult = await this.$confirm('此操作将永久删除该电桩(*包含该桩号对应的所有枪号), 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已经取消删除！')
      }
      let url=row.pileCode === null || row.pileCode === '' || row.pileCode === undefined?this.ids:row.pileCode;
        const { data: res } = await this.$http.post(`kc-device-info/delKcDeviceInfo/${url}`)
        if (res.code !== 0) {
          return this.$message.error('删除电桩失败！')
        }
        this.$message.success('删除电桩成功！')
        this.check_event()
    },
    // 批量删除的复选框选择事件
    handleSelectionChange(value) {
      if (value.length > 0) {
        this.ids = ''
        this.pileNumbers = ''
        console.log(value)
        const newValue = []
        const newPileNumbers = []
        value.forEach(item => {
          newValue.push(item.id)
          newPileNumbers.push(item.pileCode)
        })
        Array.from(new Set(newValue)).forEach(item => {
          this.ids += item + ','
        })
        Array.from(new Set(newPileNumbers)).forEach(item => {
          this.pileNumbers += item + ','
        })
        // substring(index, array/string.length - n)
        //  n代表去掉后几位，index 从下标为index开始
        this.ids = this.ids.substring(0, this.ids.length - 1)
        console.log(this.ids, 'ids');
        this.pileNumbers = this.pileNumbers.substring(0, this.pileNumbers.length - 1)
        new Set()
        // 方法返回是一个类数组，需要结合 ...运算符或者Array.from()，转成真实数组
        // console.log([...new Set(newValue)]  === Array.from(new Set(newValue)))
      }
    },
    // 导出
    async exportElePile() {
      if (this.ids === '' || this.ids === null || this.ids === undefined) {
        this.$alert('电桩选择不能为空', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
            this.$message({
              type: 'error',
              message: '请选择要导出的电桩！'
            })
          }
        })
      } else {
        const { data: res } = await this.$http.get('pileInfo/exportExcel/' + this.ids + '/' + Number(window.sessionStorage.getItem('adminId')), { responseType: 'blob' })
        saveBlobToFile(res, '电桩列表')
        if (res) {
          this.$message.success('文件导出成功')
        }
        else {
          this.$message.error('文件导出失败')
        }
      }
    }
  }
};
</script>

